module.exports = __webpack_public_path__ + "img/Invoice.1c1331b1.jpg";